/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { Configuration } from '../configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AgentResult } from '../models/agent-result';
import { apiAgentsAgentIdSessionsSessionIdAudioGet } from '../fn/agents/api-agents-agent-id-sessions-session-id-audio-get';
import { ApiAgentsAgentIdSessionsSessionIdAudioGet$Params } from '../fn/agents/api-agents-agent-id-sessions-session-id-audio-get';
import { apiAgentsAgentIdSessionsSessionIdAudioSynthesizePost } from '../fn/agents/api-agents-agent-id-sessions-session-id-audio-synthesize-post';
import { ApiAgentsAgentIdSessionsSessionIdAudioSynthesizePost$Params } from '../fn/agents/api-agents-agent-id-sessions-session-id-audio-synthesize-post';
import { apiAgentsDuplicatePost } from '../fn/agents/api-agents-duplicate-post';
import { ApiAgentsDuplicatePost$Params } from '../fn/agents/api-agents-duplicate-post';
import { apiAgentsGet } from '../fn/agents/api-agents-get';
import { ApiAgentsGet$Params } from '../fn/agents/api-agents-get';
import { apiAgentsIdCampaignTemplateGet } from '../fn/agents/api-agents-id-campaign-template-get';
import { ApiAgentsIdCampaignTemplateGet$Params } from '../fn/agents/api-agents-id-campaign-template-get';
import { apiAgentsIdDelete } from '../fn/agents/api-agents-id-delete';
import { ApiAgentsIdDelete$Params } from '../fn/agents/api-agents-id-delete';
import { apiAgentsIdDispatchGet } from '../fn/agents/api-agents-id-dispatch-get';
import { ApiAgentsIdDispatchGet$Params } from '../fn/agents/api-agents-id-dispatch-get';
import { apiAgentsIdDispatchPost } from '../fn/agents/api-agents-id-dispatch-post';
import { ApiAgentsIdDispatchPost$Params } from '../fn/agents/api-agents-id-dispatch-post';
import { apiAgentsIdGet } from '../fn/agents/api-agents-id-get';
import { ApiAgentsIdGet$Params } from '../fn/agents/api-agents-id-get';
import { apiAgentsIdPublicGet } from '../fn/agents/api-agents-id-public-get';
import { ApiAgentsIdPublicGet$Params } from '../fn/agents/api-agents-id-public-get';
import { apiAgentsPost } from '../fn/agents/api-agents-post';
import { ApiAgentsPost$Params } from '../fn/agents/api-agents-post';
import { apiAgentsPut } from '../fn/agents/api-agents-put';
import { ApiAgentsPut$Params } from '../fn/agents/api-agents-put';
import { CreateResult } from '../models/create-result';
import { DispatchAgentResult } from '../models/dispatch-agent-result';
import { GetAgentSessionAudioResult } from '../models/get-agent-session-audio-result';
import { GetAgentsResult } from '../models/get-agents-result';
import { GetCampaignTemplateResult } from '../models/get-campaign-template-result';
import { GetPublicAgentResult } from '../models/get-public-agent-result';
import { SynthesizeSessionAudioResult } from '../models/synthesize-session-audio-result';


/**
 * Agent management
 */
@Injectable({ providedIn: 'root' })
export class AgentsService extends BaseService {
  constructor(config: Configuration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiAgentsGet()` */
  static readonly ApiAgentsGetPath = '/api/Agents';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentsGet$Response(params?: ApiAgentsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAgentsResult>> {
    const obs = apiAgentsGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentsGet(params?: ApiAgentsGet$Params, context?: HttpContext): Observable<GetAgentsResult> {
    const resp = this.apiAgentsGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetAgentsResult>): GetAgentsResult => r.body)
    );
  }

  /** Path part for operation `apiAgentsPut()` */
  static readonly ApiAgentsPutPath = '/api/Agents';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentsPut()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentsPut$Response(params?: ApiAgentsPut$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateResult>> {
    const obs = apiAgentsPut(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentsPut$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentsPut(params?: ApiAgentsPut$Params, context?: HttpContext): Observable<CreateResult> {
    const resp = this.apiAgentsPut$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<CreateResult>): CreateResult => r.body)
    );
  }

  /** Path part for operation `apiAgentsPost()` */
  static readonly ApiAgentsPostPath = '/api/Agents';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentsPost$Response(params?: ApiAgentsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateResult>> {
    const obs = apiAgentsPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentsPost(params?: ApiAgentsPost$Params, context?: HttpContext): Observable<CreateResult> {
    const resp = this.apiAgentsPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<CreateResult>): CreateResult => r.body)
    );
  }

  /** Path part for operation `apiAgentsIdGet()` */
  static readonly ApiAgentsIdGetPath = '/api/Agents/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentsIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentsIdGet$Response(params: ApiAgentsIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentResult>> {
    const obs = apiAgentsIdGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentsIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentsIdGet(params: ApiAgentsIdGet$Params, context?: HttpContext): Observable<AgentResult> {
    const resp = this.apiAgentsIdGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AgentResult>): AgentResult => r.body)
    );
  }

  /** Path part for operation `apiAgentsIdDelete()` */
  static readonly ApiAgentsIdDeletePath = '/api/Agents/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentsIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentsIdDelete$Response(params: ApiAgentsIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiAgentsIdDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentsIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentsIdDelete(params: ApiAgentsIdDelete$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiAgentsIdDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiAgentsDuplicatePost()` */
  static readonly ApiAgentsDuplicatePostPath = '/api/Agents/duplicate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentsDuplicatePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentsDuplicatePost$Response(params?: ApiAgentsDuplicatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateResult>> {
    const obs = apiAgentsDuplicatePost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentsDuplicatePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentsDuplicatePost(params?: ApiAgentsDuplicatePost$Params, context?: HttpContext): Observable<CreateResult> {
    const resp = this.apiAgentsDuplicatePost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<CreateResult>): CreateResult => r.body)
    );
  }

  /** Path part for operation `apiAgentsIdDispatchGet()` */
  static readonly ApiAgentsIdDispatchGetPath = '/api/Agents/{id}/dispatch';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentsIdDispatchGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentsIdDispatchGet$Response(params: ApiAgentsIdDispatchGet$Params, context?: HttpContext): Observable<StrictHttpResponse<DispatchAgentResult>> {
    const obs = apiAgentsIdDispatchGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentsIdDispatchGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentsIdDispatchGet(params: ApiAgentsIdDispatchGet$Params, context?: HttpContext): Observable<DispatchAgentResult> {
    const resp = this.apiAgentsIdDispatchGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<DispatchAgentResult>): DispatchAgentResult => r.body)
    );
  }

  /** Path part for operation `apiAgentsIdDispatchPost()` */
  static readonly ApiAgentsIdDispatchPostPath = '/api/Agents/{id}/dispatch';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentsIdDispatchPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentsIdDispatchPost$Response(params: ApiAgentsIdDispatchPost$Params, context?: HttpContext): Observable<StrictHttpResponse<DispatchAgentResult>> {
    const obs = apiAgentsIdDispatchPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentsIdDispatchPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentsIdDispatchPost(params: ApiAgentsIdDispatchPost$Params, context?: HttpContext): Observable<DispatchAgentResult> {
    const resp = this.apiAgentsIdDispatchPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<DispatchAgentResult>): DispatchAgentResult => r.body)
    );
  }

  /** Path part for operation `apiAgentsIdPublicGet()` */
  static readonly ApiAgentsIdPublicGetPath = '/api/Agents/{id}/public';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentsIdPublicGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentsIdPublicGet$Response(params: ApiAgentsIdPublicGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetPublicAgentResult>> {
    const obs = apiAgentsIdPublicGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentsIdPublicGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentsIdPublicGet(params: ApiAgentsIdPublicGet$Params, context?: HttpContext): Observable<GetPublicAgentResult> {
    const resp = this.apiAgentsIdPublicGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetPublicAgentResult>): GetPublicAgentResult => r.body)
    );
  }

  /** Path part for operation `apiAgentsIdCampaignTemplateGet()` */
  static readonly ApiAgentsIdCampaignTemplateGetPath = '/api/Agents/{id}/campaign-template';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentsIdCampaignTemplateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentsIdCampaignTemplateGet$Response(params: ApiAgentsIdCampaignTemplateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetCampaignTemplateResult>> {
    const obs = apiAgentsIdCampaignTemplateGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentsIdCampaignTemplateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentsIdCampaignTemplateGet(params: ApiAgentsIdCampaignTemplateGet$Params, context?: HttpContext): Observable<GetCampaignTemplateResult> {
    const resp = this.apiAgentsIdCampaignTemplateGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetCampaignTemplateResult>): GetCampaignTemplateResult => r.body)
    );
  }

  /** Path part for operation `apiAgentsAgentIdSessionsSessionIdAudioGet()` */
  static readonly ApiAgentsAgentIdSessionsSessionIdAudioGetPath = '/api/Agents/{agentId}/sessions/{sessionId}/audio';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentsAgentIdSessionsSessionIdAudioGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentsAgentIdSessionsSessionIdAudioGet$Response(params: ApiAgentsAgentIdSessionsSessionIdAudioGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAgentSessionAudioResult>> {
    const obs = apiAgentsAgentIdSessionsSessionIdAudioGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentsAgentIdSessionsSessionIdAudioGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgentsAgentIdSessionsSessionIdAudioGet(params: ApiAgentsAgentIdSessionsSessionIdAudioGet$Params, context?: HttpContext): Observable<GetAgentSessionAudioResult> {
    const resp = this.apiAgentsAgentIdSessionsSessionIdAudioGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetAgentSessionAudioResult>): GetAgentSessionAudioResult => r.body)
    );
  }

  /** Path part for operation `apiAgentsAgentIdSessionsSessionIdAudioSynthesizePost()` */
  static readonly ApiAgentsAgentIdSessionsSessionIdAudioSynthesizePostPath = '/api/Agents/{agentId}/sessions/{sessionId}/audio/synthesize';

  /**
   * Queue TTS-synthesis of the session using the caller-picked TTS/voice
   * for the user role (agent replies are voiced with agent's own TTS).
   * Runs as a Hangfire job; completion is broadcast via SignalR
   * AgentSessionUpdated.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgentsAgentIdSessionsSessionIdAudioSynthesizePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentsAgentIdSessionsSessionIdAudioSynthesizePost$Response(params: ApiAgentsAgentIdSessionsSessionIdAudioSynthesizePost$Params, context?: HttpContext): Observable<StrictHttpResponse<SynthesizeSessionAudioResult>> {
    const obs = apiAgentsAgentIdSessionsSessionIdAudioSynthesizePost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Queue TTS-synthesis of the session using the caller-picked TTS/voice
   * for the user role (agent replies are voiced with agent's own TTS).
   * Runs as a Hangfire job; completion is broadcast via SignalR
   * AgentSessionUpdated.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgentsAgentIdSessionsSessionIdAudioSynthesizePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgentsAgentIdSessionsSessionIdAudioSynthesizePost(params: ApiAgentsAgentIdSessionsSessionIdAudioSynthesizePost$Params, context?: HttpContext): Observable<SynthesizeSessionAudioResult> {
    const resp = this.apiAgentsAgentIdSessionsSessionIdAudioSynthesizePost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<SynthesizeSessionAudioResult>): SynthesizeSessionAudioResult => r.body)
    );
  }

}
